import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/sync-settings')({
    validateSearch: (
        search: Record<string, unknown>,
    ): { readonly editAccountId?: string } => ({
        editAccountId:
            typeof search['editAccountId'] === 'string' &&
            search['editAccountId'].length > 0
                ? search['editAccountId']
                : undefined,
    }),
    head: () => ({
        meta: [
            {
                title: 'Sync Settings | Phoebe Admin',
            },
        ],
    }),
});
